import ApiService from '../api.service'
import type { AxiosError } from 'axios'

interface ErrorResponseData {
  message?: string
}

class ResponseError extends Error {
  errorCode: number
  errorMessage: string

  constructor(errorCode: number, message: string = '') {
    super(message)
    this.name = 'ResponseError'
    this.message = message
    this.errorCode = errorCode
    this.errorMessage = message
  }
}

const HomeService = {
  home: async function (params: string) {
    try {
      return await ApiService.get('/api/home' + params)
    } catch (error: unknown) {
      if (isAxiosError<ErrorResponseData>(error)) {
        const status = error.response?.status ?? 500
        const message = error.response?.data?.message ?? 'Unexpected error'
        throw new ResponseError(status, message)
      }
      throw new ResponseError(500, 'Unexpected error')
    }
  },
}

// 🔍 Helper type guard
function isAxiosError<T = unknown>(error: unknown): error is AxiosError<T> {
  return (error as AxiosError<T>).isAxiosError
}

export { HomeService, ResponseError }
